import { render, staticRenderFns } from "./AffiliateGallery.vue?vue&type=template&id=e15e21fa&"
import script from "./AffiliateGallery.vue?vue&type=script&lang=js&"
export * from "./AffiliateGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports